export type AddressMode = 'manual' | 'auto';
